<script>
import Button from "@core/components/common/Button";
import { BModal } from 'bootstrap-vue'
import Explanation from "@core/components/common/expression-language/Explanation.vue";

export default {
    components: {Explanation, BModal, Button},
    props: {
        explanation: {
            required: true
        }
    },
    methods: {
        show() {
            this.$refs['explanation-modal'].show();
        },
        hide() {
            this.$refs['explanation-modal'].hide();
        }
    }
}
</script>

<template>
    <b-modal
        ref="explanation-modal"
        cancel-variant="outline-secondary"
        centered
        size="xl"
        hide-footer
    >
        <Explanation
            :explanation="explanation"
        />
    </b-modal>
</template>

<style scoped lang="scss">

</style>
